import React, { Component } from 'react';
import { Link } from 'react-router-dom';


export class ProductEdit extends Component {
    static displayName = ProductEdit.name;

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            code: "",
            title: "",
            description: "",
            price: "",
            imgUrl: "",
            file: null
        };
        this.renderProductEdit = this.renderProductEdit.bind(this);
        this.handleImageChange = this.handleImageChange.bind(this);
    };

    componentWillMount() {

        if (this.props.location.state !== undefined) {
            this.setState({
                code: this.props.location.state.product.code,
                title: this.props.location.state.product.title,
                description: this.props.location.state.product.description,
                price: this.props.location.state.product.price,
                imgUrl: this.props.location.state.product.imgUrl
            });
        }

    }

    componentDidMount() {

        if (this.props.location.state !== undefined) {
            this.setState({
                code: this.props.location.state.product.code,
                title: this.props.location.state.product.title,
                description: this.props.location.state.product.description,
                price: this.props.location.state.product.price,
                imgUrl: this.props.location.state.product.imgUrl
            });
        }
    }

    handleImageChange(event) {
        this.setState({
            imgUrl: URL.createObjectURL(event.target.files[0]),
            file: event.target.files[0]
        });
    };

    backToAdm() {
        this.props.history.push({
            pathname: '/product-adm'
        });
    };

    handleSubmit(event) {
        event.preventDefault();

        const product = {
            code: this.state.code,
            title: this.state.title,
            description: this.state.description,
            price: this.state.price
        }

        const formData = new FormData();
        formData.append('metadata', JSON.stringify(product));
        formData.append('file', this.state.file);

        fetch('api/Product/Post/', {
            method: 'POST',
            body: formData
        }).then(response => response.json())
            .then(data => {
                if (JSON.stringify(data === '1'))
                    this.backToAdm();
                else
                    window.alert("Ocurrio un error");
            });

    };

    handleChange = ({ target }) => {
        this.setState({
            [target.name]: target.value
        });
    };

    renderProductEdit() {
        
        return (
            <form onSubmit={e => this.handleSubmit(e)}>
                <div className="form-gruop">
                    <label>Codigo</label>
                    <input type="text" className="form-control" name="code"
                        value={this.state.code}
                        onChange={this.handleChange} required />

                    <label>Titulo</label>
                    <input type="text" className="form-control" name="title"
                        value={this.state.title}
                        onChange={this.handleChange} required />

                    <label>Descripcion</label>
                    <textarea className="form-control" rows="4" name="description"
                        value={this.state.description}
                        onChange={this.handleChange} required />

                    <label>Precio</label>
                    <input type="text" className="form-control" name="price"
                        value={this.state.price}
                        onChange={this.handleChange} required />

                    <label>Imagen</label>
                    <input type="file" className="form-control-file" onChange={this.handleImageChange} />
                    <div>
                        <img className="img-fluid" src={this.state.imgUrl} alt="image" />
                    </div>
                    <button type="submit" className="btn btn-primary">Aceptar</button>
                    <Link to={{ pathname: '/product-adm' }}>
                        Cancelar
                    </Link>

                </div>
            </form>
        );
    };

    render() {
        
        let contents = this.renderProductEdit();
        return (
            <div>
                <h1>Producto</h1>
                {contents}
            </div>
        );
    }
}
